<template>
  <div>
    <v-layout align-center>
      <v-flex>
        <v-card xs12 sm10>
          <!-- <v-layout row wrap align-center> -->
            <!-- <v-flex class="text-xs-center"> -->
              <!-- <v-btn>test</v-btn> -->
            <!-- </v-flex> -->
          <!-- </v-layout> -->
          <span></span>
          
          <!-- <v-avatar class="mx-3 my-3" :size="120" color="cardgray">
            <img v-bind:src='user.photoURL' alt='avatar image'>
          </v-avatar> -->

          <v-card-title>
            <div class="headline">My profile</div>
          </v-card-title>

          <v-card-text>
            <h3>Public user name:</h3> 
            <p>{{ user.displayName }}</p>
            <h3>Email:</h3>
            <p> {{ user.email}}<br>
              <span v-if="user.emailVerified"><em>This email address has been verified.</em></span>
              <span v-else><em>This email address <strong>HAS NOT</strong> been verified.</em></span>
            </p>

            <h4>Account created:</h4> <p>{{ user.metadata.creationTime }}</p>
            <h4>Last sign in:</h4> <p>{{ user.metadata.lastSignInTime }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="primary" to="tour">Take me on the tour</v-btn>
            <v-btn flat color="primary" to="reset-password">Reset password</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
  // import axios from 'axios'
  import firebase from 'firebase'

  export default {
    data () {
      return {
        // username: firebase.auth().currentUser.uid(true),
      }
    },
    created () {
      // console.log('Fetching token...')
      // console.log('Token: ', this.idToken)
      this.user = firebase.auth().currentUser
      // console.log(this.user)
    },

    mounted () {
      // console.log('Profile component mounted')
    },

    methods: {
      // logout () {
      //   console.log('Logging out...')

      //   firebase.auth().signOut().then(() => {
      //     // Sign-out successful.
      //     console.log('...you have been logged out.')
      //   }).catch((err) => {
      //     // An error happened.
      //     console.log('Error upon logging out: ' + err)
      //   })
      // },
      logToken: function () {
        firebase.auth().currentUser.getIdToken(true)
          .then((idToken) => {
            this.$set(this.$data, 'idToken', idToken)
            console.log('token: ', idToken)
          }).catch((error) => {
            console.log('error: ', error)
          })
      },
      logUser: () => {
        console.log(firebase.auth().currentUser)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/Profile.vue